import { useAuth } from '@/contexts/AuthContext';
import { GUEST_USER_ID } from '@/contexts/FocusTimerContext';

/**
 * localStorage keys for the Wellbeing page's on-device notes. Per user, so a
 * shared family laptop never shows one student another's worries. Nothing
 * under these keys is ever sent to the server.
 */
export const wellbeingKeys = (userId: string) => ({
  mood: `xonera:mood:${userId}`,
  worries: `xonera:worries:${userId}`,
  /** Last technique, length and sound choice on the Breathe page. */
  breathe: `xonera:breathe:${userId}`,
});

export function useWellbeingKeys() {
  const { user } = useAuth();
  return wellbeingKeys(user?.id ?? GUEST_USER_ID);
}

/** `2026-10-01`, local time. Lives in `lib/` so hooks can use it too. */
export { localDateKey } from '@/lib/wellbeing/thoughtDate';
